/**
 * Graph Types and Time Series Strategies
 *
 * Constants for the portfolio graph system. Each calculator specifies
 * its recommended graph type and time series strategy.
 */

const GraphTypes = {
	COMPARISON_BARS: 'comparison_bars', // 2-bar chart (Contributions vs Total Value)
	TIME_SERIES_LINE: 'time_series_line', // Single line showing value over time
	TIME_SERIES_STACKED: 'time_series_stacked', // Stacked area chart by share class over time
};

const TimeSeriesStrategies = {
	FUND_CAPITAL_ACCOUNT: 'fund_capital_account', // Replay events: contributions, distributions, RoC
	VALUATION_BASED: 'valuation_based', // Use share price × owned at each valuation date
	VALUATION_BY_CLASS: 'valuation_by_class', // Per-class valuations for stacked time series
	SINGLE_CLASS: 'single_class', // Single class time series (for class-specific view)
	INCOME_ALLOCATIONS: 'income_allocations', // Tax basis: contributions + income allocations - distributions
};

export { GraphTypes, TimeSeriesStrategies };
